type ObservantFunction<T> = (newValue: T, oldValue: T) => unknown
export class Observable<T> {
    
    constructor(private _value: T, changeObservers?: ObservantFunction<T>|ObservantFunction<T>[]) {
        this.observingT = changeObservers ? Array.isArray(changeObservers) ? changeObservers : [changeObservers] : [];
    }

    get value() {
        return this._value;
    }

    mutate(newValue: T) {
        const oldValue = this._value;
        if (newValue === oldValue) return;
        this._value = newValue;
        console.log('[mutate] changing to', newValue, 'notifying', this.observingT)
        for (const observer of this.observingT) {
            observer(newValue, oldValue);
        }
    }

    addObservers(observers: ObservantFunction<T>|ObservantFunction<T>[]) {
        observers = Array.isArray(observers) ? observers : [observers];
        for (const observer of observers) {
            const found = this.observingT.find(o => o.toString() == observer.toString())
            if (!found) this.observingT.push(observer);
        }
    }

    removeObservers(observers: ObservantFunction<T>|ObservantFunction<T>[]) {
        observers = Array.isArray(observers) ? observers : [observers];
        for (const observer of observers) {
            const foundIdx = this.observingT.findIndex(o => o.toString() == observer.toString())
            if (foundIdx >= 0) this.observingT.splice(foundIdx, 1);
        }
    }

    private observingT: ObservantFunction<T>[] = []
    // private proxy: typeof Proxy

    // constructor(private _value: T, onChange: (newValue: T, oldValue:T, _: any) => any) {
    //     this.proxy = new Proxy(this._value, {
    //         set(obj: T, prop: string|symbol, value: T[keyof T]) {
                
    //             return Reflect.set(obj, prop, value)
    //     }})
    // }

    // get value(): T {
    //     return this.proxy as T;
    // }

    // private setInterceptor(obj: T, prop: keyof T, value: T[keyof T]) {
        
    // }


    // onChange()
}